import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule } from "@bfx/primeng/dialog";
import { MenuModule } from "@bfx/primeng/menu";
import { DataTableModule } from "@bfx/primeng/datatable";
import { TableModule } from "@bfx/primeng/table";

import { BfxPopupNotificationService } from "./services/bfx-popup-notification.service";
import { BfxPopupNotificationContainerComponent } from "app/bfx-notifications/bfx-popup-notification-container.component";
import { BfxPopupNotificationComponent } from "app/bfx-notifications/bfx-popup-notification.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BrandingComponentsModule } from "shared/branding/branding-components.module";
import { BfxPopupSettingProviderService } from "app/bfx-notifications/services/bfx-popup-setting-provider.service";

@NgModule({
  imports: [
    DialogModule,
    CommonModule,
    FlexLayoutModule,
    MenuModule,
    DataTableModule,
    NativeDesktopModule,
    TableModule,
    BaseComponentsModule,
    BrandingComponentsModule,
  ],
  providers: [BfxPopupNotificationService, BfxPopupSettingProviderService],
  declarations: [BfxPopupNotificationContainerComponent, BfxPopupNotificationComponent],
  exports: [BfxPopupNotificationContainerComponent, BfxPopupNotificationComponent],
})
export class BfxPopupNotificationModule {}
